import { Box, Typography, useTheme } from "@mui/material";
import { ResponsiveSankey } from "@nivo/sankey";
import { formatTo2Decimals } from "../grid/columnDefinitions/columnDefinitions";
import { useMemo } from "react";

export const rootNodeBracket = "__Root__";

const Sankey = ({ data }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const totalRootValue = useMemo(() => data.links.filter((l) => l.source && String(l.source).startsWith(rootNodeBracket)).reduce((sum, l) => sum + (l.value || 0), 0), [data]);
  return (
    <Box sx={{ height: 600, width: "100%", minWidth: 1000 }}>
      <ResponsiveSankey
        data={data}
        margin={{ top: 40, right: 50, bottom: 40, left: 50 }}
        align="justify"
        nodeOpacity={1}
        nodeThickness={20}
        nodeColor={{ from: "color" }}
        linkOpacity={0.5}
        linkBlendMode="multiply"
        enableLinkGradient={true}
        labelPosition="inside"
        labelOrientation="horizontal"
        labelPadding={16}
        labelTextColor={isDark ? "#f8fafc" : "#000"}
        theme={{
          labels: {
            text: { fontSize: 14, fill: isDark ? "#f8fafc" : "#000", fontFamily: "Poppins, sans-serif", fontWeight: 300 },
          },
          axis: {
            ticks: {
              text: { fontSize: 12, fill: isDark ? "#a1a1aa" : "#475569", fontFamily: "Poppins, sans-serif" },
            },
          },
          tooltip: {
            container: {
              background: isDark ? "#1c1c1e" : "#fff",
              color: isDark ? "#e2e8f0" : "#334155",
              fontSize: "12px",
              borderRadius: "6px",
              boxShadow: isDark ? "0 4px 12px rgba(0,0,0,0.5)" : "0 4px 12px rgba(0,0,0,0.1)",
              border: `1px solid ${isDark ? "#3f3f46" : "#e2e8f0"}`,
            },
          },
        }}
        label={"label"}
        valueFormat={(value) => formatTo2Decimals(value)}
        linkTooltip={({ link }) => {
          const value = link.value || 0;
          const percentage = totalRootValue > 0 ? ((value / totalRootValue) * 100).toFixed(2) : null;

          return (
            <Box sx={{ border: 1, borderColor: isDark ? "#3f3f46" : "lightgrey", padding: 2, borderRadius: 2, backgroundColor: isDark ? "#1c1c1e" : "white" }}>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Box sx={{ height: 16, width: 16, backgroundColor: link.source.color, borderRadius: 1 }} />
                <Typography sx={{ fontWeight: 500, color: isDark ? "#f1f5f9" : "inherit" }}>{link.source.label}</Typography>
                <Typography sx={{ color: isDark ? "#94a3b8" : "inherit" }}>→</Typography>
                <Typography sx={{ fontWeight: 500, color: isDark ? "#f1f5f9" : "inherit" }}>{link.target.label}</Typography>
                <Box sx={{ height: 16, width: 16, backgroundColor: link.target.color, borderRadius: 1 }} />
              </Box>
              <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}>
                <Typography sx={{ color: isDark ? "#e4e4e7" : "inherit" }}>{formatTo2Decimals(value)}</Typography>
                {percentage !== null && <Typography sx={{ color: isDark ? "#94a3b8" : "inherit" }}>{percentage}%</Typography>}
              </Box>
            </Box>
          );
        }}
      />
    </Box>
  );
};
export default Sankey;
